import React from 'react';
import { AnimatedCounter } from '../UI/AnimatedCounter';
export const Stats = () => {
  const stats = [{
    value: 9,
    label: 'Active Cities'
  }, {
    value: 300,
    label: 'Community Members',
    suffix: '+'
  }, {
    value: 100,
    label: 'Careers & Businesses Powered',
    suffix: '+'
  }, {
    value: 12,
    label: 'Salons Curated'
  }];
  return <section className="py-16 border-b-2 border-gray-300 bg-secondary/5" data-id="element-635" data-mp="ibzk3opu2dn3">
      <div className="container mx-auto px-4" data-id="element-636" data-mp="md1kw9zeexr6">
        <h2 className="text-3xl font-bold text-center mb-12 text-secondary-dark scroll-animate" data-id="element-637" data-mp="mbqgc7y4plz0">
          Our Impact
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-638" data-mp="dk80xz90ba6z">
          {stats.map((stat, index) => <div key={index} className={`bg-white border-2 border-dashed border-gray-300 rounded-lg p-6 card-interactive scroll-animate-scale stagger-${index + 1}`} data-id="element-639" data-mp="11991z1fifj28" data-mpi={index}>
              <AnimatedCounter end={stat.value} suffix={stat.suffix || ''} className="text-4xl font-bold text-primary" data-id="element-640" data-mp="23af8okfaz93l" />
              <div className="mt-2 text-secondary" data-id="element-641" data-mp="2d0qe6bemxqcl">{stat.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
};